/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */
import React from "react"

import "./design.scss"

import "./layout.scss"

import "../i18n"

class BackgroundImage extends React.Component<
  any,
  {
    images: string[]
    selectedImage: string
    selectedIndex: number
  }
> {
  componentDidMount() {}

  render() {
    return (
      <div className="main" style={{}}>
        {this.props.children}
      </div>
    )
  }
}

export default BackgroundImage
